import React from "react";
import { Route } from "react-router-dom";
import useUserStore from "../../stores/user";
import NotFound from "../NotFound";

const EntityAdminRoute = ({ component: Component, render, children, ...rest }) => {
  const isEntitySuperAdmin = useUserStore((state) => state.isEntitySuperAdmin);
  const isDashboardAllowedOrgAdmin = useUserStore(
    (state) => state.isDashboardAllowedOrgAdmin,
  );
  const userLoading = useUserStore((state) => state.userLoading);
  const allowed = isEntitySuperAdmin || isDashboardAllowedOrgAdmin;

  if (children) {
    return (
      <Route {...rest}>
        {userLoading ? null : allowed ? children : <NotFound />}
      </Route>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userLoading) {
          return null;
        }
        if (!allowed) {
          return <NotFound />;
        }
        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};

export default EntityAdminRoute;
